import { ApiBaseService } from '../api-base.service';
import { Injectable } from '@angular/core';
import { ProjectDto } from '../_dtos/projects.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectApiService extends ApiBaseService {
  override scope = 'project';

  createProject(variantId?: number | null) {
    return this.post<ProjectDto>({
      variant_id: variantId ?? null
    }, 'create');
  }

  createImage(projectUuid: string, styleId: string, image: File, additionalData?: Record<string, string>) {
    const formData = new FormData();
    formData.append('styleId', styleId.toString());
    formData.append('image', image);

    // Add additional data for style placeholders
    if (additionalData) {
      Object.entries(additionalData).forEach(([key, value]) => {
        formData.append(`additional_data[${key}]`, value);
      });
    }

    return this.postForm<{ data: ProjectDto }>(
      formData,
      `${projectUuid}/generate-image`
    );
  }

  getUserProjects(): Observable<{ data: ProjectDto[] }> {
    return this.get<{ data: ProjectDto[] }>('');
  }

  getProjectById(projectId: string): Observable<{ data: ProjectDto }> {
    return this.get<{ data: ProjectDto }>(projectId);
  }

  /**
   * Get project status - for polling generation status
   */
  getProjectStatus(projectId: string): Observable<{ data: ProjectDto }> {
    return this.get<{ data: ProjectDto }>(`${projectId}/status`);
  }

  saveProjectEmail(email: string, projectId?: string) {
    return this.post<any>({ email, project_id: projectId ?? null }, 'save-email');
  }

  canGenerate() {
    // device id attached in device-id.interceptor.ts
    return this.post<{ can_generate: boolean }>([], 'can-generate');
  }

  /**
   * Toggle image modification
   * @param projectId Project UUID
   * @param resultId Result UUID
   * @param modificationType Type of modification (e.g., 'no_background', 'sepia_filter')
   * @param enabled true = enable modification, false = disable (revert to original)
   * @param mediaId Optional - source media ID to modify (if not provided, uses selected/first)
   */
  toggleModification(
    projectId: string,
    resultId: string,
    modificationType: string,
    enabled: boolean = true,
    mediaId?: number
  ): Observable<{
    image_url: string;
    modifications: string[];
    selected_media_id: number;
  }> {
    const url = mediaId
      ? `${projectId}/results/${resultId}/toggle-modification/${modificationType}/${mediaId}?enabled=${enabled}`
      : `${projectId}/results/${resultId}/toggle-modification/${modificationType}?enabled=${enabled}`;

    return this.post<{
      image_url: string;
      modifications: string[];
      selected_media_id: number;
    }>({}, url);
  }

}
